// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__9Ruhp"};